/**
 * 工作区数据服务
 * 处理工作区相关的API请求
 */

import api from "./api"
import endpoints from "./endpoints"


const workspaceService = {
  /**
   * 获取工作区列表
   * @returns {Promise} - 工作区列表数据
   */
  getWorkspaces: async () => {
    try {
      const response = await api.get(endpoints.teams.list)
      
      // 兼容处理API返回数据
      // 1. 如果是数组直接返回
      if (Array.isArray(response)) {
        return response;
      }
      
      // 2. 如果是对象且有items属性，返回其中的items
      if (response && response.items && Array.isArray(response.items)) {
        return response.items;
      }
      
      // 3. 如果是对象且有data属性，返回其中的data
      if (response && response.data && Array.isArray(response.data)) {
        return response.data;
      }
      
      // 4. 如果是对象且有workspaces属性，返回其中的workspaces
      if (response && response.workspaces && Array.isArray(response.workspaces)) {
        return response.workspaces;
      }
      
      // 5. 返回空数组，避免前端报错
      console.warn("工作区数据格式不正确，返回空数组")
      return [];
    } catch (error) {
      console.error("获取工作区列表失败:", error)
      // 发生错误时返回空数组
      return [];
    }
  },


  /**
   * 获取工作区详情
   * @param {string} id - 工作区ID
   * @returns {Promise} - 工作区详情数据
   */
  getWorkspaceDetail: async (id) => {
    try {
      const response = await api.get(endpoints.teams.detail(id));
      
      // 处理可能的不同响应格式
      if (response) {
        return response;
      }
      
      // 如果没有响应数据，返回 null
      console.warn("没有找到工作区详情数据");
      return null;
    } catch (error) {
      console.error(`获取工作区详情失败 (ID: ${id}):`, error)
      // 发生错误时返回 null
      return null;
    }
  },

  /**
   * 更新工作区信息
   * @param {string} id - 工作区ID
   * @param {Object} data - 更新的数据
   * @returns {Promise} - 更新结果
   */
  updateWorkspaceInfo: async (id, data) => {
    try {
      console.log('更新工作区信息:', { id, data });
      const response = await api.put(endpoints.teams.update(id), data);
      
      if (response) {
        console.log('工作区信息更新成功:', response);
        return response;
      }
      
      throw new Error('更新失败：没有返回有效的响应');
    } catch (error) {
      console.error(`更新工作区信息失败 (ID: ${id}):`, error)
      throw error
    }
  },

  /**
   * 上传工作区头像
   * @param {string} id - 工作区ID
   * @param {File} file - 头像文件
   * @returns {Promise} - 上传结果
   */
  uploadAvatar: async (id, file) => {
    try {
      const formData = new FormData();
      formData.append('avatar', file);
      
      const response = await api.post(`/teams/${id}/avatar`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      if (response && response.url) {
        return response;
      }
      
      throw new Error('上传失败：没有返回有效的URL');
    } catch (error) {
      console.error(`上传工作区头像失败 (ID: ${id}):`, error)
      throw error
    }
  },
}

export default workspaceService
